import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import { Typography } from "antd";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';  
import { Link } from "react-router-dom";
import SkeltonList from "../../../components/SkeltonEffect/list";
import Pagination from "@mui/material/Pagination";

const PreviewPopUp = ({ popUpOpen, togglePopUp, usersDetails=[] }) => {
  const handleCancel = () => {
    togglePopUp([]);
    setCurrentRows([]);
    setTotalPages(0)

  }

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const[ jsonData, setJsonData] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;
  const [start, setStart] = useState(0);
  const [currentRowsData, setCurrentRows] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [countData, setCountData] = useState({});

  useEffect(()=>{
    setJsonData(usersDetails);
    const start = (currentPage - 1) * rowsPerPage;
    const currentRows = usersDetails.slice(start, start + rowsPerPage);
    const totalPages = Math.ceil(usersDetails?.length / rowsPerPage);
    setStart(start);
    setCurrentRows(currentRows);
    setTotalPages(totalPages);
  },[usersDetails?.length]);

  /*********************************************************
   *  This function is for handle page change
   *********************************************************/
  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);

    const start = (newPage - 1) * rowsPerPage;
    const currentRows = jsonData.slice(start, start + rowsPerPage);

    setStart(start);
    setCurrentRows(currentRows);
  };


  return (
    <Dialog
      open={popUpOpen}
      onClose={handleCancel}
      fullWidth={true}
      maxWidth={"md"}
      PaperProps={{
        className: "myDialogPopUp",
      }}
    >
      <div className="myDrawer">
        <div className="inventory_popup_title">
          <Typography variant="h5" component="div" gutterBottom className="inventory_popup_title_heading">
            Order's List
          </Typography>
          <Link to={false} style={{ position: "absolute", right: 8, top: 8, color: "#dd5151" }} onClick={handleCancel}>
            <FontAwesomeIcon icon={faTimesCircle} />
          </Link>
        </div>
        <div>
          {/* <div className="inventory_all_tabs">
            <div className="all_tabs_value">
              <label htmlFor="name" className="all_section_for_label_main_class" > Winners Nos. : {`${countData?.totalCount}`}</label>
            </div>

            <div className="all_tabs_value">
              <label htmlFor="name" className="all_section_for_label_main_class" > Straight Amount : {`${countData?.straightPoint}`}</label>
            </div>

            <div className="all_tabs_value">
              <label htmlFor="name" className="all_section_for_label_main_class" > Rumble Amount : {`${countData?.rumblePoint}`}</label>
            </div>

            <div className="all_tabs_value">
              <label htmlFor="name" className="all_section_for_label_main_class" > Chance Amount : {countData?.chancePoint}</label>
            </div>

            <div className="all_tabs_value">
              <label htmlFor="name" className="all_section_for_label_main_class" > Total Amount : {countData?.totalPoint}</label>
            </div>
          </div> */}
        </div>

        <Typography variant="body1" component="div" className="my_delete_popup_paragraph">
          <div className="container-fluid">
            <div className="categories_open_popup_main_contnet">
              <form>
                <div className="form-group row">
                  {/* <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <label htmlFor="code" className="all_lable_for_vendor_dashbaord">Search :</label>
                    <input type="text" name="name" id="name" placeholder="Search" className="form-control categories_select_tg_enter_product" />
                  </div> */}

                  <div id="content-wrapper" className="d-flex flex-column">
                    <div className="card shadow mb-4">
                      <div className="card-body pt-0">
                        <div className="table-responsive">
                          <table
                            className="table table-bordered"
                            id="dataTable"
                            width="100%"
                            cellspacing="0"
                          >
                            <thead>
                              <tr>
                                <th>Sl. No.</th>
                                <th>Order No.</th>
                                <th>Seller's Details</th>
                                <th>Area</th>
                                <th>Coupon Code</th>
                              </tr>
                            </thead>
                            <tbody>
                              {currentRowsData?.length > 0 ? (
                                currentRowsData.map((items, index) => (
                                  <>
                                    <tr key={index} onClick={()=> console.log(items)}>
                                      <td> {index + 1} </td>
                                      <td>{items?.order_id || items?.order_no}</td>
                                      <td>
                                        Name : {`${items?.seller_first_name} ${items?.seller_last_name}`} <br/>
                                        Ph. No : {items?.seller_mobile}
                                      </td>

                                      <td>{items?.area}</td>
                                      <td>{items?.ticket?.join(',')}</td>
                                    </tr>
                                  </>
                                ))
                              ) : isLoading ? <SkeltonList row={5} col={8} /> : <tr> 
                                  <td colspan="8" className="img-center" >No data found !</td> 
                              </tr>}
                            </tbody>
                          </table>
                          {totalPages > 0 && (
                            <div className="table_pagination_sales_order">
                              <Pagination
                                count={parseInt(totalPages)}
                                onChange={handlePageChange}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
  

                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div className="inventory_open_popup_action_btn">
                      <button type="button" className="btn btn-light categories_cancel_button" onClick={handleCancel}>Cancel</button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </Typography>
        {error && <div style={{ color: 'red' }}>{error}</div>}
      </div>
    </Dialog>
  );
};

export default PreviewPopUp;
